module.exports = __webpack_public_path__ + "static/media/homer.993beedd.png";